import _ from 'lodash';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import Tooltip from '@mui/material/Tooltip';

import { ExpandMoreIcon, ExpandLessIcon } from '../../customStyles/images';
import { AntSwitch } from '../../customStyles/switch';


export const userListData = {
  aiBlocked: ({ header, rowData, handleTableAction }) => {
    const { id } = header;
    const value = _.get(rowData, id);

    return (
      <Tooltip title={value === false ? '關閉 AI 對話' : '啟用 AI 對話'}>
        <Switch
          size="small"
          checked={value === true ? false : true}
          onChange={(e) => handleTableAction(e, { id, data: rowData })}
        />
      </Tooltip>
    );
  },
  wishedItems: ({ header, rowData, isDropDown, setIsDropDown }) => {
    const { id } = header;
    const value = _.get(rowData, id);
    const limit = 1;

    return (
      <>
        {value.length ? (
          <Stack variant='between-start'>
            <Box sx={{ maxWidth: '95%' }}>
              <Box>
                {value.slice(0, limit).map(item => {
                  return (
                    <Typography variant='body_sm' key={item.identity} display='block' paddingTop='4px'>
                      {item.product_meta_data.product_title}
                    </Typography>
                  )
                })}
              </Box>
              <Collapse
                in={isDropDown}
                timeout="auto"
                unmountOnExit
              >
                {value.slice(limit).map(item => {
                  return (
                    <Typography variant='body_sm' key={item.identity} display='block' mt={0.5}>
                      {item.product_meta_data.product_title}
                    </Typography>
                  )
                })}
              </Collapse>
            </Box>

            {value.length > limit &&
              <Box
                onClick={() => setIsDropDown(prev => !prev)}
                sx={{ cursor: 'pointer' }}
              >
                {isDropDown ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Box>
            }
          </Stack>)
          : ('--')
        }
      </>
    )
  },
}


